import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { Lock } from 'lucide-react';
export function Offer() {
  return <section id="offer-section" className="py-24 bg-tactical-dark border-b border-tactical-border relative overflow-hidden" data-id="element-173">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-2xl h-full bg-tactical-cta/5 blur-[150px] rounded-full pointer-events-none" data-id="element-174"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl relative z-10" data-id="element-175">
        <FadeIn data-id="element-176">
          <div className="bg-tactical-panel border-2 border-zinc-800 p-8 sm:p-12 text-center relative" data-id="element-177">
            {/* Corner accents */}
            <div className="absolute top-0 left-0 w-8 h-8 border-t-4 border-l-4 border-tactical-cta" data-id="element-178"></div>
            <div className="absolute top-0 right-0 w-8 h-8 border-t-4 border-r-4 border-tactical-cta" data-id="element-179"></div>
            <div className="absolute bottom-0 left-0 w-8 h-8 border-b-4 border-l-4 border-tactical-cta" data-id="element-180"></div>
            <div className="absolute bottom-0 right-0 w-8 h-8 border-b-4 border-r-4 border-tactical-cta" data-id="element-181"></div>

            <h2 className="text-3xl sm:text-4xl font-bold uppercase mb-6" data-id="element-182">
              No necesitas otro curso de mil dólares ni una membresía de
              gimnasio que no usarás.
            </h2>
            <p className="text-xl text-tactical-accent font-oswald uppercase tracking-wide mb-8" data-id="element-183">
              Necesitas un sistema de ejecución.
            </p>

            <div className="max-w-2xl mx-auto text-zinc-400 mb-10" data-id="element-184">
              Por el precio de una cena rápida, obtienes el mapa exacto para
              dejar de ser un espectador y convertirte en el operador de tu
              propia vida.
            </div>

            <div className="inline-block bg-zinc-950 border border-zinc-800 px-12 py-8 mb-10" data-id="element-185">
              <div className="text-sm font-mono text-zinc-500 uppercase tracking-widest mb-2" data-id="element-186">
                Inversión Única
              </div>
              <div className="text-6xl sm:text-7xl font-bold font-mono text-zinc-100 flex items-start justify-center" data-id="element-187">
                <span className="text-3xl mt-2 text-tactical-cta" data-id="element-188">$</span>6.39
                <span className="text-xl mt-8 ml-2 text-zinc-500" data-id="element-189">USD</span>
              </div>
            </div>

            <div data-id="element-190">
              <Button variant="primary" className="w-full sm:w-auto sm:px-16 py-5 text-xl" data-id="element-191">
                ¡Quiero Empezar Mi Transformación Ahora!
              </Button>
              <div className="mt-4 flex items-center justify-center gap-2 text-sm text-zinc-500 font-mono" data-id="element-192">
                <Lock className="w-4 h-4" data-id="element-193" />
                <span data-id="element-194">Acceso Seguro e Inmediato</span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}